import { GetFilesResponse } from '@orbit/api-types'
import { queryKeys } from '@lib/queryKeys'
import { useGet } from './useApi'

export function useFiles(tripId: string | undefined) {
	return useGet<GetFilesResponse>(
		queryKeys.files(tripId ?? ''),
		`/trips/${tripId}/files`,
		{ enabled: !!tripId },
	)
}
